import { render, staticRenderFns } from "./UploadTab.vue?vue&type=template&id=355bf3e7&scoped=true&"
import script from "./UploadTab.vue?vue&type=script&lang=js&"
export * from "./UploadTab.vue?vue&type=script&lang=js&"
import style0 from "./UploadTab.vue?vue&type=style&index=0&id=355bf3e7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355bf3e7",
  null
  
)

export default component.exports